import baseAPI from "@/http";

const router = "api/relatorioadministrativo/relatorioadministrativo";

export const administrativeReportAPI = {
  create: (administrativeReport) => baseAPI.post(router, administrativeReport),
  update: (administrativeReport) => baseAPI.put(router, administrativeReport),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getByCity: (id, filters = {}) => {
    // Construir query parameters apenas com valores preenchidos
    const queryParams = [];

    if (filters.usuarioId) {
      queryParams.push(`usuarioId=${filters.usuarioId}`);
    }

    if (filters.statusRelatorioId) {
      queryParams.push(`statusRelatorioId=${filters.statusRelatorioId}`);
    }

    if (filters.dataInicialString) {
      queryParams.push(
        `dataInicio=${encodeURIComponent(filters.dataInicialString)}`
      );
    }

    if (filters.dataFinalString) {
      queryParams.push(
        `dataFim=${encodeURIComponent(filters.dataFinalString)}`
      );
    }

    // Construir URL com query parameters
    let url = `${router}/get-by-municipio/${id}`;
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return baseAPI.get(url);
  },
  getByFilter: (filter) => baseAPI.post(`${router}/get-by-filtro`, filter),
  getByUser: (id, contratoid) =>
    baseAPI.get(`${router}` + "/get-by-usuario" + `/${id}/${contratoid}`),
  analyse: (report) =>
    baseAPI.put(`${router}` + "/analisar-relatorio-administrativo", report),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  downloadAnexo: (relatorioAnexoId) =>
    baseAPI.post(
      "api/arquivo/anexo/download/relatorio-administrativo/" + relatorioAnexoId,
      null,
      { responseType: "blob" }
    ),
  deleteAnexo: (id) =>
    baseAPI.delete(
      `api/arquivo/anexo/excluir-relatorio-administrativo-anexo/${id}`
    ),
};
